import { useTranslation } from 'module/hooks/use-translation';
import { Button, Drawer } from '@rocketlane/ui';
import { FC } from 'react';
import { FilterWrapper } from './components';

interface Props {
  title: string | React.ReactNode;
  onDone: () => void;
  visible: boolean;
  onClose: VoidFunction;
  filterComponent: React.ReactNode;
}

export const BaseFilterDrawer: FC<Props> = ({
  title,
  visible,
  onClose,
  onDone,
  filterComponent,
}) => {
  return (
    <Drawer
      size={800}
      placement="right"
      open={visible}
      onClose={onClose}
      title={title}
      content={<FilterWrapper>{visible && filterComponent}</FilterWrapper>}
      footer={
        <>
          <Button
            variant="secondary"
            onClick={onClose}
            data-cy="filter-drawer.cancel"
          >
            {useTranslation('cancel')}
          </Button>
          <Button
            variant="primary"
            onClick={onDone}
            data-cy="filter-drawer.done"
          >
            {useTranslation('done')}
          </Button>
        </>
      }
    />
  );
};
